import { Injectable, inject } from '@angular/core';
import { SpeechService } from '../speech/speech.service';
import { LocalLearningStore } from '../storage/local-learning-store';

@Injectable({ providedIn: 'root' })
export class NaturalStoppingPointService {
  private readonly speech = inject(SpeechService);
  private readonly store = inject(LocalLearningStore);
  private observer: MutationObserver | null = null;

  start(): void {
    if (
      typeof document === 'undefined' ||
      typeof MutationObserver === 'undefined' ||
      !document.body ||
      this.observer
    ) {
      return;
    }

    const sync = (): void => this.ensureStoppingPoint();
    this.observer = new MutationObserver(sync);
    this.observer.observe(document.body, { childList: true, subtree: true });
    queueMicrotask(sync);
  }

  private ensureStoppingPoint(): void {
    const actions = document.querySelector<HTMLElement>('.complete-card .completion-actions');
    if (!actions || actions.querySelector('[data-natural-stop]')) {
      return;
    }

    const card = actions.closest<HTMLElement>('.complete-card');
    if (card && !card.querySelector('.natural-stop-copy')) {
      const copy = document.createElement('p');
      copy.className = 'natural-stop-copy';
      copy.textContent = 'Puoi fermarti qui. Se vuoi, puoi anche scegliere un altro gioco.';
      card.insertBefore(copy, actions);
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'natural-stop-button';
    button.setAttribute('data-natural-stop', 'true');
    button.setAttribute('aria-label', 'Ho finito per ora');

    const icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';
    const label = document.createElement('span');
    label.textContent = 'Ho finito';
    button.append(icon, label);

    button.addEventListener('click', () => {
      void this.stopForNow(button);
    });
    actions.prepend(button);
  }

  private async stopForNow(button: HTMLButtonElement): Promise<void> {
    if (button.disabled) {
      return;
    }

    button.disabled = true;
    this.speech.cancel();
    try {
      await this.store.setActiveProfileId(null);
      window.location.reload();
    } catch {
      button.disabled = false;
      button.replaceChildren('Riprova');
    }
  }
}
